import React from 'react';

function ApkDownload() {
  const apkUrl = '/Risale-i Nur Radyo.apk';

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      color: '#fff'
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.1)',
        backdropFilter: 'blur(10px)',
        borderRadius: '20px',
        padding: '40px',
        textAlign: 'center',
        maxWidth: '400px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
      }}>
        <div style={{
          width: '100px',
          height: '100px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 20px',
          fontSize: '50px'
        }}>
          📻
        </div>

        <h1 style={{
          margin: '0 0 10px 0',
          fontSize: '1.8rem',
          fontWeight: '600'
        }}>
          Risale-i Nur Radyo
        </h1>

        <p style={{
          color: 'rgba(255,255,255,0.7)',
          margin: '0 0 30px 0',
          fontSize: '0.95rem',
          lineHeight: '1.5'
        }}>
          Android uygulamasını indirin ve Risale-i Nur derslerini her an dinleyin.
        </p>

        <a
          href={apkUrl}
          download="Risale-i Nur Radyo.apk"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '10px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: '#fff',
            padding: '15px 30px',
            borderRadius: '12px',
            textDecoration: 'none',
            fontSize: '1.1rem',
            fontWeight: '600',
            transition: 'transform 0.2s, box-shadow 0.2s',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.6)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
          }}
        >
          <span style={{ fontSize: '1.3rem' }}>⬇</span>
          APK İndir
        </a>

        <p style={{
          color: 'rgba(255,255,255,0.5)',
          margin: '20px 0 0 0',
          fontSize: '0.8rem'
        }}>
          Android 5.0 ve üzeri
        </p>
      </div>
    </div>
  );
}

export default ApkDownload;
